module.exports = __webpack_public_path__ + "img/homeIncome1.93212f07.png";